<template>
  <div class="device-list">
    <div class="device-list__search">
      <div class="device-list__search--left">
        <el-autocomplete
          size="mini"
          prefix-icon="el-icon-search"
          v-model="search"
          :fetch-suggestions="querySearchAsync"
          placeholder="搜索"
          @select="handleSelect"
        ></el-autocomplete>
      </div>
      <div class="device-list__search--right">
        <el-select
          size="mini"
          v-model="form.device_type"
          placeholder="请选择">
          <el-option
            v-for="item in deviceTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-scrollbar class="device-list__collapse">
      <el-collapse v-model="floorsOpen" accordion>
        <el-collapse-item :title="floor.floor_name" :name="index" v-for="(floor, index) in floors"
:key="index" class="device-list__collapse-item" @click.native="handleClick(floor)">
          <div v-for="(device, dIndex) in floor.device_list" :key="dIndex" :class="[{ active: device.isActive }, 'device-list__collapse-block']"
@click.stop="handleClickItem(device)" @dblclick.stop="handleDoubleClickItem(device, floor)">
            {{device.name}}
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-scrollbar>
  </div>
</template>

<script>
import clonedeep from 'lodash.clonedeep';
import { getFloors } from '@/api/deployment';
import { deviceTypes as deviceTypesConfig } from '@/config/deviceTypes.js';
import eventHub from '@/utils/eventHub';
import { events } from '@/utils/events'
;
const deviceTypes = clonedeep(deviceTypesConfig);
export default {
  data() {
    return {
      search: '',
      form: {
        place_id: this.$route.query.place_id,
        project_id: this.$route.query.project_id,
        device_type: deviceTypes[0].value,
      },
      deviceTypes,
      floorsOpen: [0],
      floors: [],
      devices: [],
      activeUUID: '',
    };
  },
  created() {
    this.getFloors();
    eventHub.$on(events.DEVICE_CHECKED, this.eventDeviceChecked);
    eventHub.$on(events.CANCEL_DEVICE_CHECKED, this.eventCancelDeviceChecked);
    eventHub.$on(events.REFRESH_DEVICE_LIST, this.eventRefreshDeviceList);
  },
  methods: {
    eventDeviceChecked(uuid) {
      this.activeUUID = uuid;
      this.setChecked();
    },
    eventCancelDeviceChecked() {
      this.activeUUID = null;
      this.setChecked();
    },
    eventRefreshDeviceList() {
      this.refresh();
    },
    getFloors(isRefresh) {
      const { form } = this;
      getFloors(form).then((res) => {
        this.floors = res.data;
        this.generateDevices();
        if (!isRefresh) {
          this.handleClick(this.floors[0]);
        }
        this.setChecked();
      });
    },
    refresh() {
      this.getFloors(true);
    },
    setChecked() {
      const { floors, activeUUID } = this;
      floors.forEach((floor) => {
        const { device_list: devices } = floor;
        devices.forEach((device) => {
          if (device.point_uuid === activeUUID) {
            this.$set(device, 'isActive', true);
          } else {
            this.$set(device, 'isActive', false);
          }
        });
      });
    },
    handleClick(floor) {
      eventHub.$emit(events.FLOOR_CHECKED, floor);
    },
    handleClickItem(device) {
      eventHub.$emit(events.DEVICE_CHECKED, device.point_uuid);
    },
    handleDoubleClickItem(device, floor) {
      eventHub.$emit(events.DEVICE_DOUBLE_CLICKED, device, floor);
    },
    generateDevices() {
      let devices = [];
      const { floors } = this;
      floors.forEach((floor, fIndex) => {
        const { device_list } = floor;
        device_list.forEach(device => {
          devices.push({
            fIndex,
            device,
            value: device.name
          })
        })
      })
      this.devices = devices;
    },
    querySearchAsync(queryString, cb) {
      const { devices } = this;
      const results = queryString ? devices.filter(this.createStateFilter(queryString)) : devices;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return state.value.includes(queryString);
      };
    },
    handleSelect(item) {
      const { fIndex, device } = item;
      this.floorsOpen = fIndex;
      this.handleClick(this.floors[fIndex]);
      this.handleClickItem(device);
    }
  },
  beforeDestroy() {
    eventHub.$off(events.DEVICE_CHECKED, this.eventDeviceChecked);
    eventHub.$off(events.CANCEL_DEVICE_CHECKED, this.eventCancelDeviceChecked);
    eventHub.$off(events.REFRESH_DEVICE_LIST, this.eventRefreshDeviceList);
  },
};
</script>

<style lang="less" scoped>
@deepBlack: #18191A;
@shadowBlack: #2C2C2E;
@highLightBlack: #979797;
@lightBlack: #353537;
.device-list {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  /deep/.el-scrollbar__wrap {
    overflow: scroll;
    height: calc(100% + 6px);
    // hack，为何下方会出现横向滚动条
  }
  &__search {
    flex: none;
    display: flex;
    padding: 10px;
    /deep/.el-input__inner {
      background-color: @deepBlack;
      border-color: @deepBlack;
      color: #ffffff;
      border-radius: 10px;
    }
    &--left {
      flex: 1;
      margin-right: 10px;
    }
    &--right {
      flex: 1;
    }
  }
  &__collapse {
    flex: auto;
    height: 100%;
    border-radius: 0 0 10px 10px;
    /deep/.el-collapse {
      border: 0;
    }
    /deep/.el-collapse-item__wrap {
      border-color: @deepBlack;
    }
    /deep/.el-collapse-item__header {
      background: @lightBlack;
      color: #ffffff;
      border-color: @shadowBlack;
      padding-left: 15px;
      padding-right: 10px;
      cursor: pointer;
    }
    /deep/.el-collapse-item__content {
      padding: 0;
      background: @shadowBlack;
      color: #ffffff;
      cursor: pointer;
    }

  }
  &__collapse-item {
    .active {
      background: @highLightBlack;
    }
  }
  &__collapse-block {
    height: 30px;
    line-height: 30px;
    // margin: 0 10px;
    padding: 0 10px;
    cursor: pointer;
  }
}
</style>
